/* The Home -> Workspace composer hand-off: a two-BEAT animation that runs entirely on the
 * Workspace, after the page has already changed.
 *
 * A single view transition tweened the hero card into the docked bar, changing position and
 * size at once. It never looked right at any duration — a ::view-transition-group animates
 * width and height as well as transform, which is main-thread work, and it landed on the same
 * frames where the Workspace reveals a whole grid — and more basically, a thing that resizes
 * while it travels reads as neither.
 *
 * So the page CUTS, and then the docked bar plays the hand-off by itself. Both changes start
 * on the same frame, but the width is DONE within the first fifth of the journey: the bar is
 * already the right shape while it is still most of the way from where it came, so what you
 * read is a thing arriving, not a thing morphing. Sequencing them strictly — thin, THEN move —
 * was an earlier attempt and it put a visible stall at the top of the travel.
 *
 * Nothing about this is visible on Home — Home is gone by the first frame of it.
 *
 * This module is the seam: Home leaves the geometry it had, Workspace picks it up on its
 * first visible frame. Read once and cleared, so a direct visit animates nothing.
 */

// Back to 320ms. A 700ms version with an eased-in-out travel was tried and reverted: slowing
// it down made the movement easy to watch and also easy to notice, which is the opposite of
// what a hand-off between two pages wants.
export const DOCK_SLIDE_MS = 320;                              // the travel
export const DOCK_THIN_MS = Math.round(DOCK_SLIDE_MS * 0.2);   // the width, finished inside it

// Derived, never written twice: the ratio IS the design here, and two hand-tuned numbers
// would drift the moment either is adjusted.

/* The curves, as they were: the standard material ease on the travel, and a pure ease-out on
   the width so all of its motion is at the front of its short window. */
export const DOCK_SLIDE_EASE = "cubic-bezier(0.4, 0, 0.2, 1)";
export const DOCK_THIN_EASE = "cubic-bezier(0, 0, 0.2, 1)";

let handoffFrom = null;

export const leaveComposerAt = (rect) => {
  handoffFrom = rect ? { top: rect.top, width: rect.width } : null;
};

export const takeComposerFrom = () => {
  const v = handoffFrom;
  handoffFrom = null;
  return v;
};
